import { render, staticRenderFns } from "./Uploadpage.vue?vue&type=template&id=e588d498&scoped=true&"
import script from "./Uploadpage.vue?vue&type=script&lang=js&"
export * from "./Uploadpage.vue?vue&type=script&lang=js&"
import style0 from "./Uploadpage.vue?vue&type=style&index=0&id=e588d498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e588d498",
  null
  
)

export default component.exports